module.exports = __webpack_public_path__ + "assets/bfa2cad945e48b7056e92e8917cf2f4f.png";